import type { PaymentIntentCreatePayload } from '~/composables/api/payment-intent/useFetchPaymentIntent'

export default () => {
  const { initStripe } = useStripe()
  const { mutateAsync: createPaymentIntent } = useMutationPaymentIntent.create()
  const { mutateAsync: confirmPaymentIntent } = useMutationPaymentIntent.confirm()
  const { activeWorkspaceId } = useAuth()

  const getPaymentIntent = async (intentData: PaymentIntentCreatePayload) => {
    const stripe = await initStripe()

    if (!stripe || !activeWorkspaceId.value)
      return

    const intent = await createPaymentIntent({ workspaceId: activeWorkspaceId.value, payload: intentData }).then(({ data }) => data)

    switch (intent.attributes.status) {
      case 'requires_source_action':
      case 'requires_action': {
        const res = await stripe.handleCardAction(intent.attributes.clientSecret)
        if (res?.error)
          throw res.error

        const confirmedIntent = await confirmPaymentIntent({
          workspaceId: activeWorkspaceId.value,
          intentId: intent.id,
        }).then(({ data }) => data)

        if (confirmedIntent.attributes.status !== 'requires_capture')
          throw new Error(`Invalid payment intent status: ${confirmedIntent.attributes.status}`)

        return confirmedIntent.id
      }
      case 'requires_capture':
        return intent.id
      default:
        throw new Error(`Invalid payment intent status: ${intent.attributes.status}`)
    }
  }

  return {
    getPaymentIntent,
  }
}
